import { StandardEvents } from '@shopify/events';
class MayaFittedMat extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    this.generation = 0;
    this.closest('.shopify-section')?.addEventListener(StandardEvents.productSelect, async (event) => {
      if (event.target.closest('product-card')) return;
      const generation = ++this.generation;
      this.setAttribute('aria-busy', 'true');
      this.querySelectorAll('button').forEach(button => button.disabled = true);
      try {
        const result = await event.promise;
        if (!this.isConnected || generation !== this.generation) return;
        const replacement = result?.detail?.html?.querySelector('maya-fitted-mat[data-product-id="' + this.dataset.productId + '"]');
        if (!replacement) { this.hidden = true; return; }
        this.innerHTML = replacement.innerHTML;
        this.hidden = false;
      } catch {
        if (generation === this.generation) this.hidden = true;
      } finally {
        if (generation === this.generation) this.removeAttribute('aria-busy');
      }
    }, { signal: this.controller.signal });
  }
  disconnectedCallback() { this.controller?.abort(); }
}
if (!customElements.get('maya-fitted-mat')) customElements.define('maya-fitted-mat', MayaFittedMat);